import React from "react";

const WorkProcessShape = () => {
	return (
		<svg width={670} height={1172} viewBox="0 0 670 1172" fill="none">
			<g filter="url(#filter0_f_0_1)">
				<path
					d="M306.21 538.904C276.401 690.325 375.265 837.034 527.025 866.59C678.787 896.145 825.979 797.355 855.788 645.933C885.597 494.513 786.735 347.803 634.973 318.247C483.211 288.692 336.019 387.483 306.21 538.904Z"
					fill="url(#paint0_radial_0_1)"
					fillOpacity="0.7"
				/>
			</g>
			<g filter="url(#filter1_f_0_1)">
				<path
					d="M485.081 420.225C469.251 500.639 521.753 578.55 602.348 594.246C682.943 609.942 761.112 557.478 776.942 477.063C792.772 396.65 740.27 318.737 659.675 303.042C579.08 287.346 500.911 339.81 485.081 420.225Z"
					fill="url(#paint1_radial_0_1)"
					fillOpacity="0.8"
				/>
			</g>
			<defs>
				<filter
					id="filter0_f_0_1"
					x="0.90625"
					y="13.0208"
					width="1160.19"
					height="1158.8"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feGaussianBlur
						stdDeviation={150}
						result="effect1_foregroundBlur_0_1"
					/>
				</filter>
				<filter
					id="filter1_f_0_1"
					x="182.265"
					y="0.266113"
					width="897.494"
					height="896.756"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feGaussianBlur
						stdDeviation={150}
						result="effect1_foregroundBlur_0_1"
					/>
				</filter>
				<radialGradient
					id="paint0_radial_0_1"
					cx={0}
					cy={0}
					r={1}
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(366.489 1196.78) rotate(-77.1551) scale(1291.47 1174.77)"
				>
					<stop offset="0.281116" stopColor="#00EBFF" />
					<stop offset="0.772529" stopColor="#161C1B" />
				</radialGradient>
				<radialGradient
					id="paint1_radial_0_1"
					cx={0}
					cy={0}
					r={1}
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(517.093 769.597) rotate(-77.1551) scale(685.852 623.876)"
				>
					<stop offset="0.627423" stopColor="#FF39B0" />
					<stop offset="0.837609" stopColor="#161C1B" />
				</radialGradient>
			</defs>
		</svg>
	);
};

export default WorkProcessShape;
